<section class="section about" id='about'>
    <div class="container">
        <div class="section-box">
            <div class="about-title" data-aos="fade-up">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> {{ aboutTitle }}
                </h3>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <div class="about-description">
                        <p *ngFor='let text of aboutParagraphs' [innerHTML]="text" data-aos="fade-up"
                            data-aos-duration="1000"></p>
                        <ul class="skills-list" data-aos="fade-up">
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">Angular &amp; React.js</span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">JavaScript &amp; TypeScript </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">Node.js &amp; ExpressJs </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">ORM &amp; Knex.js </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">PostgreSQL </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">MongoDB </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">CI / CD &amp; Git</span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">Python </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">HTML &amp; (S)CSS </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span
                                    class="underline">Bootstrap &amp; MaterialUI </span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-4 mt-md-0 text-center" data-aos="fade-up" data-aos-duration="1000">
                    <div class="about-img-container">
                        <img class="rounded" width="400" height="300"
                            src="https://res.cloudinary.com/ddtzx1ohw/image/upload/v1726503666/Portfolio/IMG_20240915_082035_v5mt8j.jpg"
                            alt="Pavan Mekala">
                        <!-- <img  class="rounded" width="400" height="300" src="https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720936890/pavan_landscape_djyodv.png" alt="Pavan Mekala"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>